import { User } from 'firebase/auth';

/**
 * Cómo llamamos al usuario en la interfaz: su nombre si lo ha puesto en
 * Configuración, y si no la parte del correo anterior a la arroba.
 */
export function nombreDeUsuario(user: User | null | undefined): string {
  return user?.displayName || user?.email?.split('@')[0] || 'Usuario';
}
